<template>
	<div class="drawer">
		<el-drawer size="1200px" title="修改门店信息" :visible.sync="drawerStatus" @close='close' :close-on-press-escape="false" :wrapperClosable="false" :modal-append-to-body="false" >
			<el-form style="padding:10px 36px 0 0px;">
				<el-row>
					<el-col :span="24">
						<el-form-item label="封面图：" :label-width="formLabelWidth" prop="nick_name">
							<img style="height: 100px;cursor: pointer;" :src="shopInfo.cover">
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="视频：" :label-width="formLabelWidth" prop="nick_name">
							<div class="imgBox">
								<div v-if="shopInfo.bannerVideo.url" class="imgItem" style="height:200px;" >
									<video
										controls
										autoplay
										loop
										muted
										style="border-radius: 6px;width:100%;height: 100%;"
									>
										<source :src="shopInfo.bannerVideo.url" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="轮播图：" :label-width="formLabelWidth" prop="nick_name">
							<div class="imgBox">
								<div v-for="(item,index) in shopInfo.bannerList" :key="index" class="imgItem">
									<img alt="" :src="item.url" style="border-radius: 6px;width:100%;height: 100%;">
								</div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="店铺名称：" :label-width="formLabelWidth" prop="nick_name">
							{{shopInfo.shopName}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="营业时间：" :label-width="formLabelWidth" prop="sex">
							{{shopInfo.workTime}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="店铺类型：" :label-width="formLabelWidth" prop="user_mobile">
							<el-select v-model="shopInfo.shopType" placeholder="请选择" disabled style="width:320px;margin-right: 16px;">
								<el-option v-for="item in [{label:'线下店并对外',value:0},{label:'线下店不对外',value:1},{label:'线上店并对外',value:2},{label:'线上店不对外',value:3}]" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="店铺电话：" :label-width="formLabelWidth" prop="sex">
							{{shopInfo.tel}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="店铺地址：" :label-width="formLabelWidth" prop="nick_name">
							{{shopInfo.address}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="店铺介绍：" :label-width="formLabelWidth" prop="nick_name">
							{{shopInfo.introduce}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="预约项目：" :label-width="formLabelWidth" prop="nick_name">
							<el-select v-model="selectValueList" multiple disabled placeholder="请选择" style="width:320px;margin-right: 16px;">
								<el-option v-for="item in selectList" :key="item.value" :label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<div style="background-color: #F5F5FA;margin:10px 0;padding-top:20px;">
					<el-row>
						<el-col :span="12">
							<el-form-item label="京东商户号：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jingDongPay.customerNum}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="京东商铺编号：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jingDongPay.shopNum}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="京东公钥：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jingDongPay.accessKey}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="京东私钥：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jingDongPay.secretKey}}
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<div style="background-color: aliceblue;margin:10px 0;padding-top:20px;">
					<el-row>
						<el-col :span="12">
							<el-form-item label="嘉联商户号：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jiaLianPay.mchId}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="嘉联公钥：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jiaLianPay.jlpayPublicKey}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="机构公钥：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jiaLianPay.merchantPublicKey}}
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="机构私钥：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jiaLianPay.merchantPrivateKey}}
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="机构号：" :label-width="formLabelWidth" prop="nick_name">
								{{shopInfo.jiaLianPay.orgCode}}
							</el-form-item>
						</el-col>
					</el-row>
				</div>
				<el-row>
					<el-col :span="12">
						<el-form-item label="建筑面积：" :label-width="formLabelWidth" prop="user_mobile">
							{{shopInfo.builtUpArea}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="实用面积：" :label-width="formLabelWidth" prop="nick_name">
							{{shopInfo.actualArea}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="店铺纬度：" :label-width="formLabelWidth" prop="user_mobile">
							{{shopInfo.location.latitude}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="店铺经度：" :label-width="formLabelWidth" prop="nick_name">
							{{shopInfo.location.longitude}}
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<!-- <div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="submit">确定</div>
			</div> -->
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth: '110px',
				
				shopInfo:{bannerVideo:{},bannerList:[],location:{},jingDongPay:{},jiaLianPay:{}},
				selectValueList:[],
				selectList:[{label:'挂号',value:'101'},{label:'美容',value:'102'},{label:'洗护',value:'103'},{label:'绝育',value:'104'},{label:'SPA',value:'106'},{label:'疫苗驱虫',value:'105'}],
				
			}
		},
		props:{
			id:{
				default:''
			}
		},
		mounted() {
			this.$nextTick(()=>{
				this.drawerStatus=true;
			})
			this.getDetail()
		},
		methods: {
			close(){
				this.$emit("submit",{type:'close'})
			},
			getDetail(){
				let params = {
					"id": this.id,
					companyId:'5e9412e0b2bfbc030160bdd5',
				}
				this.$http.get(process.env.VUE_APP_baseData+'/api/CompanyInfo/shop/info', params).then(res => {
					if (res.code == 0) {
						this.shopInfo = res.data;
						if(this.shopInfo.jingDongPay===null) {this.shopInfo.jingDongPay={}}
						if(this.shopInfo.jiaLianPay===null) {this.shopInfo.jiaLianPay={}}
						
						this.selectValueList = []
						if(!this.$public.isNull(this.shopInfo.serviceItems)){
							for(let i=0;i<this.shopInfo.serviceItems.length;i++){
								this.selectValueList.push(this.shopInfo.serviceItems[i].itemId)
							}
						}
						
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		.btnBox{
			width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
			.btnItem{
				text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
				&.submit{
					background-color: #3569FF;
				}
			}
		}
		
		
		
		
		
		
		
		
		
		.imgBox{
			display: flex;flex-wrap: wrap;
			.imgItem{
				position: relative;width:128px;height: 128px;margin:0 16px 16px 0;
				.closeBtn {
					display: block; color: red; position: absolute; top: -15px; right: -15px; font-size: 30px; z-index: 5;
				}
			}
			.avatar-uploader-icon {
				font-size: 28px; color: #8c939d; width: 128px; height: 128px; line-height: 128px; text-align: center; background: #F0F0F7; border: 1px dashed #B0B0BF; border-radius: 8px; box-sizing: border-box;
			}
		}
	}
	
</style>
